import React, { useState, useEffect } from 'react'
import Select, { SingleValue } from "react-select";
import { InputGroup, InputGroupText, Input } from "reactstrap";
import { Link, useNavigate } from 'react-router-dom';
import { Col, Form, FormFeedback, Label, Row, CardHeader, CardBody, Card, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { backendbaseUrl } from '../../../../../Utils/baseUrl';
import axiosInstance from '../../../../../Utils/axiosInstance';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import H6 from './../../../../../CommonElements/Headings/H1Element';
import CommonInput from '../../../../Buttons/DefaultStyle/InputButton';
import TextInput from '../../../../Buttons/DefaultStyle/InputButton/TextInput';
import PositiveNumberInput from '../../../../Buttons/DefaultStyle/InputButton/PositiveNumberInput';
interface Currency {
    country: {
        country_name: string;
        country_code: string;
        id: string;
    };
    currency_symbol: string;
    is_default: boolean;
}

export default function FormCard() {

    const [formData, setFormData] = useState<{
        planName: string;
        description: string;
        price: string;
        selectedApps: OptionType[];
        planValidity: string;
        numberOfUsers: string;
        currencyValue: string;
        permissions: string[];
        points: string[]; // ✅ Ensure points is string[]
    }>({
        planName: "",
        description: "",
        price: "",
        selectedApps: [],
        planValidity: "",
        numberOfUsers: "",
        currencyValue: "",
        permissions: [],
        points: [], // ✅ Explicitly set points as string[]
    });
    const [errors, setErrors] = useState<any>({});
    const [validate, setValidate] = useState(false);
    const [countryOptions, SetCountryOptions] = useState([])
    const [countryMobCode, SetCountryMobCode] = useState('')
    const [appOptions, setAppOptions] = useState([])
    const [dynamicFields, setDynamicFields] = useState<Record<string, any[]>>({});
    const [countryCurrency, setCountryCurrency] = useState()
    const [permissionChange, setPermissionChange] = useState<any>({})
    const [currency, SetCurrency] = useState<Currency[]>([])
    const [showPoints, setShowPoints] = useState(false);
    const [points, setPoints] = useState<string[]>([]);

    type OptionType = { value: string; label: string };

    const handlePointsChange = (index: number, value: string) => {
        if (value === '' || /^[1-9]\d*$/.test(value) || value === '0') {
        const updatedPoints = [...points];
        updatedPoints[index] = value;
        setPoints(updatedPoints);

        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            points: points, // ✅ Always keeps the latest state
        }));
    }, [points]); // ✅ Runs whenever points changes

    const addPointField = () => {
        setPoints([...points, ""]);
    };

    const removePointField = (index: number) => {
        const updatedPoints = points.filter((_, i) => i !== index);
        setPoints(updatedPoints);
    };

    const navigate = useNavigate();








    // const countryOptions = [
    //     { value: "IN", label: "India" },
    //     { value: "US", label: "United States" },
    //     { value: "UK", label: "United Kingdom" },
    //     { value: "CA", label: "Canada" },
    // ];



    useEffect(() => {
        const getCountryList = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/settings/country/default-country/`);
                if (response.status === 200) {
                    const countryListData = response?.data?.map((c: any) => ({
                        value: c.country.id,
                        label: c.country.country_name
                    })) || [];

                    SetCountryOptions(countryListData)
                    SetCurrency(response.data)




                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }

        getCountryList();



    }, []);



    useEffect(() => {

        const getAppsList = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/permission/default-apps`);
                if (response.status === 200) {
                    const appListData = response?.data?.map((c: { id: string, name: string }) => ({
                        value: c.id,
                        label: c.name
                    })) || [];

                    setAppOptions(appListData)

                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }
        getAppsList();

    }, [])











    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let newErrors = { ...errors };

        if (!value.trim()) {
            newErrors[name as keyof Error] = `Please enter a valid ${name}.`;
        }

        setErrors(newErrors);
    };


    const handleChange = (e: any) => {
        const { name, value } = e.target;
        if (name === "planName") {
        const sanitized = value.replace(/[^a-zA-Z0-9 \-]/g, "");
        setFormData({ ...formData, [name]: sanitized });
        if (errors[name as keyof Error]) {
            setErrors({ ...errors, [name]: undefined });
        }
        return;
    }
        setFormData({ ...formData, [name]: value });

        if (errors[name as keyof Error]) {
            setErrors({ ...errors, [name]: undefined });
        }
    };

    const handleMultiSelectChange = async (selectedOptions: any) => {
        setFormData({ ...formData, selectedApps: selectedOptions || [] });

        if (selectedOptions.length > 0) {
            setErrors({ ...errors, selectedApps: undefined });
        }


        const selectedAppIds = selectedOptions.map((option: any) => option.value);


        try {
            const newFields: Record<string, any[]> = { ...dynamicFields };

            for (const appId of selectedAppIds) {
                if (!newFields[appId]) {
                    const response = await axiosInstance.get(`${backendbaseUrl}/permission/default-permissions/${appId}`);
                    const data = response.data

                    newFields[appId] = data;
                }
            }


            console.log(newFields, "ss")
            Object.keys(newFields).forEach((key) => {
                if (!selectedAppIds.includes(key)) {
                    delete newFields[key];
                }
            });

            setDynamicFields(newFields);
        } catch (error) {
            console.error("Error fetching dynamic fields:", error);
        }

    };

    const handleCountryChange = async (selectedOption: SingleValue<{ value: string; label: string }>) => {
        if (selectedOption) {
            setFormData((prev) => ({
                ...prev,
                country: selectedOption.value, // Extract value
            }));


            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/settings/country/calling-code/?country_id=${selectedOption.value}`);
                if (response.status === 200) {

                    SetCountryMobCode(response?.data?.data?.calling_code)


                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.error("Error Retriving Country");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }
    };

    const handlePermissionChange = (
        appId: string,
        fieldId: string,
        permissionType: string,
        value: boolean,
        appName: string,
        resources: string
    ) => {
        setDynamicFields((prevFields) => {
            const updatedFields = { ...prevFields };
            const fieldIndex = updatedFields[appId].findIndex((f) => f.id === fieldId);

            if (fieldIndex !== -1) {
                updatedFields[appId][fieldIndex] = {
                    ...updatedFields[appId][fieldIndex],
                    permisssions: {
                        ...updatedFields[appId][fieldIndex].permisssions,
                        [permissionType]: value,

                    },
                };
            }

            return updatedFields; // Always return the updated object
        });
    };

    useEffect(() => {
        // Convert the object into an array
        const formattedData = Object.values(dynamicFields).flat();
        setPermissionChange(formattedData);
    }, [dynamicFields]);

    const defaultCurrency = currency.find(currency => currency.is_default) || currency[0];
    const [selectedCurrency, setSelectedCurrency] = useState(defaultCurrency?.country?.id || "");


    useEffect(() => {
        if (currency.length > 0) {
            const defaultCurrency = currency.find(c => c.is_default) || currency[0];
            setSelectedCurrency(defaultCurrency?.country?.id || "");
        }
    }, [currency]);


    const handleCurrencyChange = (e: any) => {
        setSelectedCurrency(e.target.value);
        console.log(e.target.value, "sqqwqw", e.target.name)
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };



    const [showLastCreatedPlan, setShowLastCreatedPlan] = useState(false)



    const handleSubmit = async (event: any) => {
        event.preventDefault();

        let newErrors: any = {};
        if (!formData.planName.trim()) newErrors.planName = "Plan Name is required.";
        else if (/[^a-zA-Z0-9 \-]/.test(formData.planName)) newErrors.planName = "Plan Name can only contain letters, numbers, spaces, and hyphens.";

        if (!formData.description.trim()) newErrors.description = "Description is required.";
        if (!formData.price.trim()) newErrors.price = "Price is  required.";
        if (!formData.planValidity.trim()) newErrors.planValidity = "plan validity in days is required.";
        if (!formData.numberOfUsers.trim()) newErrors.numberOfUsers = "Number of users for this plan is required.";

        if (formData.selectedApps.length === 0) newErrors.selectedApps = "Can't create plan if Apps are not selected "

        formData.currencyValue = selectedCurrency
        formData.permissions = permissionChange
        console.log(formData.points)

        if (formData.points.some((point) => point.trim() === '')) {
            toast.error("Please fill all the points");
            return;
        }


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setValidate(true);


        try {
            const response = await axiosInstance.post(`${backendbaseUrl}/plans/create/`, formData);
            if (response.status === 201 || response.status === 200) {
                toast.success("Plan created successfully!");

                setFormData({
                    planName: "",
                    description: "",
                    price: "",
                    selectedApps: [],
                    planValidity: "",
                    numberOfUsers: "",
                    currencyValue: "",
                    permissions: [],
                    points: [], // ✅ Explicitly set points as string[]
                })
                formData.currencyValue = ""
                setShowLastCreatedPlan(true)
                window.scrollTo({ top: 0, behavior: "smooth" });
                setTimeout(() => {
                    setShowLastCreatedPlan(false);
                }, 5000);

            }
            else {
                toast.error("Failed to create plan. Please try again.");
            }
        } catch (e: any) {
            console.log(e.response.status)
            if (e.response.status === 400) {
                console.log(e.response.data.message)
                toast.error(e.response?.data?.message || "An error occurred while creating the plan.");
            }
            else {
                toast.error(e.response?.data?.message || "An error occurred while creating the plan.");
            }


        }



    };
    function ListingPage(event: any): void {
        navigate("/settings/plans-and-pricing/")
    }

    return (
        <div>
            {showLastCreatedPlan ? <Col xl={12}>
                <Card className="height-equal">
                    <div className="d-flex align-items-center">
                        <CardBody className="d-flex     ">
                            <H6 className='p-10'>click here to view your last created plan </H6><Button onClick={ListingPage} className='btn-pill btn-air-primary'>view</Button>
                        </CardBody>
                    </div>
                </Card>
            </Col> : ''}
            <Row>
                <Col xl={6}>
                    <Card className="height-equal">

                        <CardBody>

                            <Form className="needs-validation custom-input" onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    {/* Company Name */}
                                    <Col xs={12}>
                                        <Label>Plan Name</Label>
                                        <TextInput
                                            name="planName"
                                            placeholder="Basic Plan"
                                            value={formData.planName}
                                            errors={errors}
                                            validate={validate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {!errors["planName"] && validate && <FormFeedback valid>Looks good!</FormFeedback>}
                                    </Col>

                                    {/* Email */}
                                    <Col xs={12}>
                                        <Label className="col-form-label">Description</Label>
                                        <TextInput
                                            name="description"
                                            placeholder="Enter Description"
                                            value={formData.description}
                                            errors={errors}
                                            validate={validate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Col>

                                    <Col xs={12}>
                                        <Label className="col-form-label">Plan validity (In days)</Label>
                                        <PositiveNumberInput
                                            name="planValidity"
                                            placeholder="30 days"
                                            value={formData.planValidity}
                                            errors={errors}
                                            validate={validate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Col>
                                    {/* 

                                    <Label className="col-form-label">Select Coutry</Label>
                                    <Select
                                        options={countryOptions}
                                        value={countryOptions.find((option: { value: string; label: string }) => option.value === formData.country) || null}

                                        onChange={(selectedOption) => handleCountryChange(selectedOption)}
                                    /> */}

                                    {/* Phone Number */}
                                    <Col xs={12}>
                                        <Label className="col-form-label">Price </Label>
                                        <InputGroup>
                                            <InputGroupText>
                                                <select value={selectedCurrency} name="currencyValue" onChange={handleCurrencyChange} className="form-select">


                                                    {currency.length > 0 ? (
                                                        currency.map((currencyItem: any) => (
                                                            <option key={currencyItem?.country?.id} value={currencyItem?.country?.id} onChange={handleCurrencyChange}>
                                                                {currencyItem?.currency_symbol} ({currencyItem?.country?.country_name || "Unknown"})
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option disabled>No currencies available</option>
                                                    )}

                                                </select>
                                            </InputGroupText>
                                            <Input
                                                type="number"
                                                className={`form-control ${errors.price ? "is-invalid" : ""} ${validate && !errors.price ? "is-valid" : ""}`}
                                                placeholder="Enter The Price for the Plan"
                                                name="price"
                                                value={formData.price}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.price && <FormFeedback>{errors.price}</FormFeedback>}
                                        </InputGroup>
                                    </Col>


                                    <Col xs={12}>
                                        <Label className="col-form-label">Number of users </Label>
                                        <InputGroup>
                                            <PositiveNumberInput
                                                name="numberOfUsers"
                                                placeholder="10 users for this plan"
                                                value={formData.numberOfUsers}
                                                errors={errors}
                                                validate={validate}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </InputGroup>
                                    </Col>


                                    <Col xs={12}>
                                        <Label>Select Apps</Label>
                                        <Select<OptionType, true>
                                            options={appOptions}
                                            isMulti
                                            value={formData.selectedApps}
                                            onChange={handleMultiSelectChange}
                                        />


                                        {errors.selectedApps && <div className="invalid-feedback d-block">{errors.selectedApps}</div>}
                                    </Col>


                                    <Col xs={12}>
                                        <Button color="secondary" onClick={() => setShowPoints(!showPoints)}>
                                            Add Some Points for this Plan
                                        </Button>
                                    </Col>
                                    {showPoints && (
                                        <Col xs={12}>

                                            {points.map((point, index) => (
                                                <div key={index} className="d-flex align-items-center mb-2">
                                                    <Input
                                                        type="text"
                                                        className="form-control me-2"
                                                        placeholder="Enter a point"
                                                        value={point}
                                                        onChange={(e) => handlePointsChange(index, e.target.value)}
                                                        onKeyDown={(e) => {
                                                            // Block minus sign, plus sign, and decimal point
                                                            if (e.key === '-' || e.key === '+' || e.key === '.') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    <Button color="danger" onClick={() => removePointField(index)}>
                                                        Remove
                                                    </Button>
                                                </div>
                                            ))}
                                            <Button color="success" onClick={addPointField}>
                                                Add
                                            </Button>
                                        </Col>
                                    )}

                                </Row>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Submit
                                </button>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={6}>
                    <Card className="height-equal">

                        <CardBody>



                            <Row className="g-3">
                                {Object.keys(dynamicFields).length === 0 ? (
                                    <div>

                                        <DotLottieReact
                                            src="https://lottie.host/c38f9e55-0add-4d20-b616-356aff2262c9/BpqVsc5Tva.lottie"
                                            loop
                                            autoplay
                                        />
                                        <p className='text-center'>Your App's Menu will appear here! once you start selecting apps......</p>
                                    </div>
                                ) : (
                                    Object.entries(dynamicFields).map(([appId, fields]) => (
                                        <Col xs={12} key={appId}>
                                            <h4>{fields[0]?.apps.name}</h4> {/* App Name as Heading */}
                                            {fields.map((field) => (
                                                <div key={field.id} className="mb-3">
                                                    <Label>{field.readable_name} ({field.resource})</Label> {/* Display resource */}
                                                    <div className="d-flex gap-3">
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={field.permisssions.create}
                                                                onChange={(e) => handlePermissionChange(appId, field.id, "create", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                            /> Create
                                                        </div>
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={field.permisssions.read}
                                                                onChange={(e) => handlePermissionChange(appId, field.id, "read", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                            /> Read
                                                        </div>
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={field.permisssions.update}
                                                                onChange={(e) => handlePermissionChange(appId, field.id, "update", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                            /> Update
                                                        </div>
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={field.permisssions.delete}
                                                                onChange={(e) => handlePermissionChange(appId, field.id, "delete", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                            /> Delete
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Col>
                                    ))
                                )}




                            </Row>


                        </CardBody>
                    </Card>
                </Col>

            </Row>


        </div>
    )
}
